// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"a08a2df0","174":"db5e13d3","362":"049a77e0","514":"f7578a24"}[chunkId] + ".chunk.css";
};